import { createCollection } from "@tanstack/react-db";
/**
 * Composite key `${scopeId}|${blockId}`. Pipe is safe — neither
 * branded id ever contains it.
 */
function rowKey(row) {
    return `${row.scopeId}|${row.blockId}`;
}
// Singleton sync handles. Set by the `sync` callback the first (and
// only) time TanStack DB initializes this collection.
let syncBegin = null;
let syncWrite = null;
let syncCommit = null;
let syncCollection = null;
let inBatch = false;
function writeUpsertImpl(item) {
    if (syncBegin === null || syncWrite === null || syncCommit === null)
        return;
    const key = rowKey(item);
    const existing = syncCollection?.get(key);
    const type = existing === undefined ? "insert" : "update";
    if (inBatch === false)
        syncBegin();
    syncWrite({ type, value: item });
    if (inBatch === false)
        syncCommit();
}
function writeDeleteImpl(key) {
    if (syncBegin === null || syncWrite === null || syncCommit === null)
        return;
    const existing = syncCollection?.get(key);
    if (existing === undefined)
        return;
    if (inBatch === false)
        syncBegin();
    syncWrite({ type: "delete", value: existing });
    if (inBatch === false)
        syncCommit();
}
function writeBatchImpl(callback) {
    if (syncBegin === null || syncCommit === null) {
        callback();
        return;
    }
    if (inBatch === true) {
        // Nested batches are flat — reuse the outer transaction.
        callback();
        return;
    }
    inBatch = true;
    syncBegin();
    try {
        callback();
    }
    finally {
        syncCommit();
        inBatch = false;
    }
}
export const collectionBlocksCollection = createCollection({
    id: "collection-blocks",
    getKey: rowKey,
    startSync: true,
    gcTime: 0,
    sync: {
        sync: (params) => {
            syncBegin = params.begin;
            syncWrite = params.write;
            syncCommit = params.commit;
            syncCollection = params.collection;
            params.markReady();
            return () => {
                syncBegin = null;
                syncWrite = null;
                syncCommit = null;
                syncCollection = null;
            };
        },
        getSyncMetadata: () => ({}),
    },
    utils: {
        writeUpsert: writeUpsertImpl,
        writeDelete: writeDeleteImpl,
        writeBatch: writeBatchImpl,
    },
});
export { rowKey as collectionBlockRowKey };
